export enum Theme {
    Light = 'light',
    Dark = 'dark'
}

export class Settings {
    public theme: Theme = Theme.Light;
}